import filterMenuItems, { filterCloudMenuItems } from "util/conditional/filterMenuItems";
import { IlluminateDotBadge } from "common/components";
import { DATA_LAKE_INTERNAL_ENABLED } from "data-lake/Constants";
import Permissions from "security-app/Permissions";
import useLicenseCheck from "license/useLicenseCheck";
import Routes from "routing/Routes";
import SecurityRoutes from "security-app/routing/Routes";
import DEFAULT_ENTERPRISE_NAV_ITEM from "components/navigation/DefaultEnterpriseNavItem";
import { DEFAULT_SECURITY_NAV_ITEM } from "components/security/bindings";
import { COLLECTIONS_ENABLED, COLLECTIONS_ROUTE } from "collections/constants";
import WatchlistRoutes from "watchlist/Routes";
import { AGENT_WORKFLOW_FEATURE_FLAG } from "aiagent/Constants";
import useAgentWorkflowsLicensed from "aiagent/hooks/useAgentWorkflowsLicensed";
import EnterpriseRoutes from "./EnterpriseRoutes";
const SECURITY_MENU_ITEMS = [
  {
    path: SecurityRoutes.THREAT_COVERAGE,
    description: "Threat Coverage",
    titleKey: "enterprise_navigation:security.threat_coverage",
    permissions: Permissions.securityApp.read,
    end: true
  },
  {
    path: Routes.SECURITY.ACTIVITY,
    description: "Activity",
    titleKey: "enterprise_navigation:security.activity",
    permissions: Permissions.securityApp.read
  },
  {
    path: SecurityRoutes.INVESTIGATIONS.LIST,
    description: "Investigations",
    titleKey: "enterprise_navigation:security.investigations",
    permissions: [
      "investigations:read",
      "streams:read:datastream:gl-security-investigations-metrics"
    ]
  },
  {
    path: Routes.SECURITY.ANOMALIES,
    description: "Anomalies",
    titleKey: "enterprise_navigation:security.anomalies",
    permissions: "anomaly_configuration:read"
  },
  {
    path: SecurityRoutes.ASSETS.list("machine"),
    description: "Assets",
    titleKey: "enterprise_navigation:security.assets",
    permissions: "asset:read"
  },
  {
    path: WatchlistRoutes.LIST,
    description: "Watchlists",
    titleKey: "enterprise_navigation:security.watchlists",
    permissions: "watchlist:read"
  }
];
const ENTERPRISE_AND_CLOUD_ROUTES = [
  {
    path: EnterpriseRoutes.OVERVIEW,
    description: "Overview",
    titleKey: "enterprise_navigation:enterprise.overview",
    permissions: "licenseinfos:read"
  },
  {
    path: EnterpriseRoutes.ARCHIVES,
    description: "Archives",
    titleKey: "enterprise_navigation:enterprise.archives",
    permissions: "archive:read"
  },
  {
    path: EnterpriseRoutes.AUDIT_LOG,
    description: "Audit Log",
    titleKey: "enterprise_navigation:enterprise.audit_log",
    permissions: "auditlog_status:read"
  },
  {
    path: EnterpriseRoutes.LICENSES,
    description: "Licenses",
    titleKey: "enterprise_navigation:enterprise.licenses",
    permissions: "licenses:read"
  },
  { path: EnterpriseRoutes.REPORTS, description: "Reports", titleKey: "enterprise_navigation:enterprise.reports" },
  {
    path: EnterpriseRoutes.CUSTOMIZATION,
    description: "Customization",
    titleKey: "enterprise_navigation:enterprise.customization",
    permissions: "clusterconfig:read"
  },
  {
    path: EnterpriseRoutes.FORWARDERS,
    description: "Forwarders",
    titleKey: "enterprise_navigation:enterprise.forwarders",
    permissions: "forwarders:edit"
  },
  {
    path: EnterpriseRoutes.AI_AGENT_WORKFLOWS,
    description: "AI Agent Workflows",
    titleKey: "enterprise_navigation:enterprise.ai_agent_workflows",
    permissions: "agent_workflow:read",
    requiredFeatureFlag: AGENT_WORKFLOW_FEATURE_FLAG,
    useCondition: useAgentWorkflowsLicensed
  },
  {
    path: EnterpriseRoutes.ILLUMINATE,
    description: "Illuminate",
    titleKey: "enterprise_navigation:enterprise.illuminate",
    permissions: "illuminate_bundle_management:read",
    BadgeComponent: IlluminateDotBadge
  },
  {
    path: EnterpriseRoutes.MY_SEARCH_FILTERS,
    description: "My Search Filters",
    titleKey: "enterprise_navigation:enterprise.my_search_filters"
  }
];
const bindings = {
  navigation: [
    {
      description: DEFAULT_ENTERPRISE_NAV_ITEM.description,
      titleKey: DEFAULT_ENTERPRISE_NAV_ITEM.titleKey,
      position: DEFAULT_ENTERPRISE_NAV_ITEM.position,
      children: filterCloudMenuItems(
        filterMenuItems(
          COLLECTIONS_ENABLED ? [...ENTERPRISE_AND_CLOUD_ROUTES, COLLECTIONS_ROUTE] : ENTERPRISE_AND_CLOUD_ROUTES,
          DATA_LAKE_INTERNAL_ENABLED ? [] : [EnterpriseRoutes.DATA_LAKE]
        ),
        [EnterpriseRoutes.LICENSES, EnterpriseRoutes.FORWARDERS]
      ),
      BadgeComponent: IlluminateDotBadge
    },
    {
      description: DEFAULT_SECURITY_NAV_ITEM.description,
      titleKey: DEFAULT_SECURITY_NAV_ITEM.titleKey,
      position: DEFAULT_SECURITY_NAV_ITEM.position,
      children: SECURITY_MENU_ITEMS,
      useCondition: () => {
        const {
          security: { isValid: isValidSecurityLicense }
        } = useLicenseCheck();
        return isValidSecurityLicense;
      }
    }
  ]
};
export default bindings;
